import { render } from "./DataProtection.vue?vue&type=template&id=99240af4&scoped=true"
import script from "./DataProtection.vue?vue&type=script&lang=js"
export * from "./DataProtection.vue?vue&type=script&lang=js"

import "./DataProtection.vue?vue&type=style&index=0&id=99240af4&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-99240af4"]])

export default __exports__